import { useState } from 'react';
import { CaretRight } from '@phosphor-icons/react';
import './Help.scss';

const TOPICS: Array<[string, string]> = [
  ['How do I choose a score level?', 'Easy uses Color Drum circles, Normal uses a colored staff, and Hard uses classic monochrome drum notation.'],
  ['Why does music start when I select a song?', 'Automatic preview is enabled by default so you can hear each track before starting. You can change this in App settings.'],
  ['Where can I see my scores?', 'Open Records from the bottom menu to review score, rank, accuracy and play date.'],
  ['How do I change the display language?', 'Open My, select App settings, then choose English or Korean.'],
];

function Help() {
  const [open, setOpen] = useState(0);

  return (
    <div className="page profile-subpage">
      <div className="page-intro"><span className="eyebrow">SUPPORT</span><h1>Help center</h1><p>Find quick answers about songs, scores and account settings.</p></div>
      <section className="help-list">
        {TOPICS.map(([question, answer], index) => (
          <button key={question} className={open === index ? 'open' : ''} onClick={() => setOpen(open === index ? -1 : index)}>
            <span>{question}<CaretRight /></span>
            {open === index && <p>{answer}</p>}
          </button>
        ))}
      </section>
    </div>
  );
}

export default Help;
